/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExaminedDto
 */
export interface CreateUpdateExaminedDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    pesel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    iDCardNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    iDCardType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExaminedDto
     */
    dateOfBirth?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    education?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    sex?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    numbers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    postalAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    learnedProfession?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    drivingLicenseIssuer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExaminedDto
     */
    drivingLicenseYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    nationality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    invoiceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    invoiceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    countryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExaminedDto
     */
    idCardTypeDictId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateExaminedDto interface.
 */
export function instanceOfCreateUpdateExaminedDto(value: object): value is CreateUpdateExaminedDto {
    return true;
}

export function CreateUpdateExaminedDtoFromJSON(json: any): CreateUpdateExaminedDto {
    return CreateUpdateExaminedDtoFromJSONTyped(json, false);
}

export function CreateUpdateExaminedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExaminedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'surname': json['surname'] == null ? undefined : json['surname'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'pesel': json['pesel'] == null ? undefined : json['pesel'],
        'iDCardNumber': json['iDCardNumber'] == null ? undefined : json['iDCardNumber'],
        'iDCardType': json['iDCardType'] == null ? undefined : json['iDCardType'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'education': json['education'] == null ? undefined : json['education'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'sex': json['sex'] == null ? undefined : json['sex'],
        'street': json['street'] == null ? undefined : json['street'],
        'numbers': json['numbers'] == null ? undefined : json['numbers'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'postalAddress': json['postalAddress'] == null ? undefined : json['postalAddress'],
        'learnedProfession': json['learnedProfession'] == null ? undefined : json['learnedProfession'],
        'drivingLicenseIssuer': json['drivingLicenseIssuer'] == null ? undefined : json['drivingLicenseIssuer'],
        'drivingLicenseYear': json['drivingLicenseYear'] == null ? undefined : json['drivingLicenseYear'],
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'invoiceName': json['invoiceName'] == null ? undefined : json['invoiceName'],
        'invoiceAddress': json['invoiceAddress'] == null ? undefined : json['invoiceAddress'],
        'countryId': json['countryId'] == null ? undefined : json['countryId'],
        'idCardTypeDictId': json['idCardTypeDictId'] == null ? undefined : json['idCardTypeDictId'],
    };
}

export function CreateUpdateExaminedDtoToJSON(value?: CreateUpdateExaminedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'surname': value['surname'],
        'firstname': value['firstname'],
        'pesel': value['pesel'],
        'iDCardNumber': value['iDCardNumber'],
        'iDCardType': value['iDCardType'],
        'dateOfBirth': value['dateOfBirth'] == null ? undefined : ((value['dateOfBirth'] as any).toISOString()),
        'education': value['education'],
        'drivingLicense': value['drivingLicense'],
        'sex': value['sex'],
        'street': value['street'],
        'numbers': value['numbers'],
        'city': value['city'],
        'postcode': value['postcode'],
        'email': value['email'],
        'phone': value['phone'],
        'postalAddress': value['postalAddress'],
        'learnedProfession': value['learnedProfession'],
        'drivingLicenseIssuer': value['drivingLicenseIssuer'],
        'drivingLicenseYear': value['drivingLicenseYear'],
        'nationality': value['nationality'],
        'nip': value['nip'],
        'invoiceName': value['invoiceName'],
        'invoiceAddress': value['invoiceAddress'],
        'countryId': value['countryId'],
        'idCardTypeDictId': value['idCardTypeDictId'],
    };
}

